import { render, staticRenderFns } from "./BatchOrderList.vue?vue&type=template&id=01042594&scoped=true"
import script from "./BatchOrderList.vue?vue&type=script&lang=js"
export * from "./BatchOrderList.vue?vue&type=script&lang=js"
import style0 from "./BatchOrderList.vue?vue&type=style&index=0&id=01042594&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01042594",
  null
  
)

export default component.exports